import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if the error is a 401 (Unauthorized) or 403 (Forbidden)
    if (error.response && (error.response.status === 401)) {
      // SessionExpiredPopup will handle the logout and redirection
      if (window.location.pathname !== '/signin') {
        const event = new Event('auth:session-expired');
        window.dispatchEvent(event);
      }
    }
    return Promise.reject(error);
  }
);